
import ItemMixin from './item'

export default {
  name: 'item-variant-dialog',
  mixins: [ItemMixin],
  data: () => ({
    variant_detail_dialog: false,
    current_item: {
      is_track_stock: true
    },
    variant_dialog_error: false,
    variant_dialog_error_text: '',
    services_headers: [],
    option_names: []
  }),
  computed: {
    disable_save() {
      let disable = false
      if (this.current_item && this.current_item.variant_options) {
        for (let i = 0; i < this.current_item.variant_options.length; i++) {
          if (!this.option_names[i] || this.option_names[i] == '') {
            disable = true
          }
        }
      }
      else {
        disable = true
      }
      return disable
    }
  },
  methods: {
    async openVariantDialogDetail(item) {
      if (item._id == null) {
        this.current_item = this.$copy(item)
        // item.price = 
        this.variant_detail_dialog = true;
        return
      }
      item = await this.get_item_by_id(item._id);
      if (item) {
        if (typeof item.price == typeof "invan") {
          item.price = item.price.replace(",", "");
        }
        if (typeof item.cost == typeof "invan") {
          item.cost = item.cost.replace(",", "");
        }
        this.option_names = item.name.split(" / ");
        this.current_item = this.$copy(item);
        this.variant_detail_dialog = true;
      }
    },
    createItemVariantActionLocal() {
      this.current_item.name = this.option_names.join(' / ')
      this.variant_items.push(this.current_item)
      this.variant_detail_dialog = false
    },
    updateItemVariantActionLocal() {
    },
    updateItemVariant() {},
    async updateItemVariantActionGlobal() {

      this.current_item.name = this.option_names.join(' / ')
      if (+this.current_item.purchase_cost) {
        this.current_item.purchase_cost = +this.current_item.purchase_cost
      }
      else {
        this.current_item.purchase_cost = 0
      }
      const res = await this.$communicator('update_item_variant_data', {
        arguments: [this.current_item._id],
        params: this.current_item
      })
      if (res && res.data && res.data.statusCode == 413) {
        this.variant_dialog_error = true
        this.variant_dialog_error_text = `The variant '${res.data.message}' already exists. Please change at least one option value.`
      }
      else if (res && res.data && res.data.statusCode == 200) {
        this.variant_dialog_error = false
        this.variant_detail_dialog = false
        this.update_items()
      }
      else if (res && res.data && res.data.statusCode == 411) {
        this.variant_dialog_error = true
        this.variant_dialog_error_text = `The variant '${this.current_item.sku}' already exists. Please change at least one option value.`
      }
      else {
        this.variant_dialog_error = true
        this.variant_dialog_error_text = `Could not update item`
      }
    },
    itemVariantActionLocal() {
      // this.variant_items.push(this.current_item)
      // this.item.services = this.item.services.concat(this.current_item.services)
      for (const service of this.current_item.services) {
        this.item.services.push(service)
      }
      this.available_sku++
      this.variant_detail_dialog = false;
      // this.current_item = {}
    },
    async createItemVariant() {
    },
    closeVariantDialog() {
      this.variant_detail_dialog = false;
    },
    updateServicePrice() {
      const services = []
      for (let i = 0; i < this.current_item.services.length; i++) {
        services.push(this.current_item.services[i])
        if(services[i].price_auto_fill != false) {
          services[i].price = +this.current_item.price
        }
      }
      this.current_item.services = services
    }
  },
  watch: {
    'current_item.price'() {
      this.updateServicePrice()
    },
    current_item() {
      if (
        this.current_item.is_track_stock ||
        this.current_item.use_production
      ) {
        this.services_headers = [
          {
            text: this.$t("available"),
            value: "available",
            sortable: false,
            width: 10,
            align: "center"
          },
          {
            text: this.$t("store"),
            value: "service_name",
            sortable: false
          },
          {
            text: this.$t("price"),
            value: "price",
            width: 100,
            sortable: false
          },
          {
            text: this.$t("currency"),
            value: "price_currency",
            width: 50,
            sortable: false
          },
          {
            text: this.$t("in_stock"),
            value: "in_stock",
            width: 100,
            sortable: false
          },
          {
            text: this.$t("low_stock"),
            value: "low_stock",
            width: 100,
            sortable: false
          },
          {
            text: this.$t("optimal_stock"),
            value: "optimal_stock",
            width: 100,
            sortable: false
          }
        ];
      } else {
        this.services_headers = [
          {
            text: this.$t("available"),
            value: "available",
            sortable: false,
            width: 10,
            align: "center"
          },
          {
            text: this.$t("store"),
            value: "service_name",
            sortable: false
          },
          {
            text: this.$t("price"),
            value: "price",
            sortable: false,
            width: 100
          },
          {
            text: this.$t("currency"),
            value: "price_currency",
            width: 50,
            sortable: false
          }
        ];
      }
    }
  }
}